<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { cn } from '$lib/utils/cn';

    import { getBoxAttributes } from '../_utils/getBoxAttributes';
    import Box from '../_wrappers/Box.svelte';

    import type { Box as BoxType } from '$lib/types/Components/SharedTypes';
    import type { Align } from '$lib/types/Components/SharedTypes';
    import type { TransitionEffect } from '$lib/types/Theme';

    export let id = '';
    export let color = 'black';
    export let align: Align = 'left';
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let wide = false;
    export let noDesktopScaling = false;
    export let isInMediaAnswer = false;
    export let box: BoxType;
    export let layout = DEFAULT_LAYOUT;
    export let wysiwygHtml: string = '';
    export let isHeading = false;

    let classes: string;

    const isInColumn = layout.isInColumn;

    const textBox: BoxType = getBoxAttributes({ box, isInColumn, isInMediaAnswer });

    const html = wysiwygHtml;

    $: classes = cn('wrapper', {
        'lg:fun-px-0': noDesktopScaling,
        'fun-text-left': align === 'left',
        'fun-text-center': align === 'center',
        'fun-text-right': align === 'right',
    });
</script>

<Box {id} {...textBox} {transitionDelay} {transitionEffect} {wide}>
    <div
        class="fun-break-words {classes}"
        style="--textColor: {color}; --linkColor: {color};"
        style:font-family={isHeading ? 'var(--heading-font-family)' : undefined}
        style:font-weight={isHeading
            ? 'var(--brand-heading-font-weight)'
            : 'var(--brand-body-font-weight)'}
    >
        {@html html}
    </div>
</Box>

<style lang="scss">
    .wrapper {
        // Empty paragraph behave like an <br> tag
        // See: https://github.com/ueberdosis/tiptap/issues/412#issuecomment-593635371
        :global(p:empty::after) {
            content: '\00A0';
            // Default to Sans Serif as some custom fonts break the page when having special chars as content
            @apply fun-font-sans;
        }

        color: var(--textColor);

        :global(code) {
            white-space: pre-wrap;
        }
    }
</style>
